import * as actionTypes from "../../actionLabels/index";

export const FactoryOwnerList = (payloadData) => {
  return {
    type: actionTypes.GET_ALL_FACTORY_OWNER,
    payload: payloadData,
  };
};
export const FactoryOwnerListActionSuccess = (getAllSptfSuccess) => {
  return {
    type: actionTypes.GET_ALL_FACTORY_OWNER_SUCCESS,
    payload: getAllSptfSuccess,
  };
};

export const FactoryOwnerListActionFail = (error) => {
  return {
    type: actionTypes.GET_ALL_FACTORY_OWNER_FAIL,
    payload: error,
  };
};

export const FactoryList = (payloadData) => {
  return {
    type: actionTypes.GET_ALL_FACTORY_LIST,
    payload: payloadData,
  };
};

export const FactoryListActionSuccess = (getAllSptfSuccess) => {
  return {
    type: actionTypes.GET_ALL_FACTORY_LIST_SUCCESS,
    payload: getAllSptfSuccess,
  };
};

export const FactoryListActionFail = (error) => {
  return {
    type: actionTypes.GET_ALL_FACTORY_LIST_FAIL,
    payload: error,
  };
};

export const createSptfAction = (payloadData) => {
  return {
    type: actionTypes.GET_ALL_SPTF_CREATE,
    payload: payloadData,
  };
};

export const createSptfActionSuccess = (getAllSptfSuccess) => {
  return {
    type: actionTypes.GET_ALL_SPTF_CREATE_SUCCESS,
    payload: getAllSptfSuccess,
  };
};

export const createSptfActionFail = (error) => {
  return {
    type: actionTypes.GET_ALL_SPTF_CREATE_FAIL,
    payload: error,
  };
};
export const createEditApiStatussptf = (error) => {
  return {
    type: actionTypes.CREATE_EDIT_API_SPTF,
    payload: error,
  };
};

export const createSptfDisable = (error) => {
  return {
    type: actionTypes.CREATE_SPTF_DISABLE,
    payload: error,
  };
};
export const searchRequest = (requestData) => ({
  type: actionTypes.SEARCH_REQUEST,
  payload: requestData,
});

export const searchSuccess = (data) => ({
  type: actionTypes.SEARCH_SUCCESS,
  payload: data,
});

export const searchFailure = (error) => ({
  type: actionTypes.SEARCH_FAILURE,
  payload: error,
});

export const getSptfRecoveryRequest = (data) => ({
  type: actionTypes.GET_SPTF_RECOVERY_REQUEST,
  payload: data

});

export const getSptfRecoverySuccess = (data) => ({
  type: actionTypes.GET_SPTF_RECOVERY_SUCCESS,
  payload: data
});

export const getSptfRecoveryFailure = (error) => ({
  type: actionTypes.GET_SPTF_RECOVERY_FAILURE,
  error
});

export const  updateSptfRecoveryRequest = (data) => ({
  type: actionTypes.UPDATE_SPTF_RECOVERY_REQUEST,
  payload: data,
});

export const updateSptfRecoverySuccess = () => ({
  type: actionTypes.UPDATE_SPTF_RECOVERY_SUCCESS,
});

export const updateSptfRecoveryFailure = (error) => ({
  type: actionTypes.UPDATE_SPTF_RECOVERY_FAILURE,
  payload: error,
});

export const deleteSptfRecoveryRequest = (sptfRecoveryId) => ({
  type: actionTypes.DELETE_SPTF_RECOVERY_REQUEST,
  payload: sptfRecoveryId
});

export const deleteSptfRecoverySuccess = () => ({
  type: actionTypes.DELETE_SPTF_RECOVERY_SUCCESS
});

export const deleteSptfRecoveryFailure = (error) => ({
  type: actionTypes.DELETE_SPTF_RECOVERY_FAILURE,
  payload: error
});